import { GRID_ZOOM_DEFAULT, GRID_ZOOM_MAX, GRID_ZOOM_MIN, GRID_ZOOM_STEP } from '../../utils/tableViewSettings';
import './GridZoomControl.css';

interface GridZoomControlProps {
  zoom: number;
  onChange: (zoom: number) => void;
  /** The table's starting level, which clicking the percentage restores. */
  defaultZoom?: number;
}

/**
 * Compact per-table zoom stepper (REG-653). The chosen level is saved for
 * that table and restored on the next visit — including after a hard refresh
 * or logging out and back in. Clicking the percentage resets to the default.
 */
export function GridZoomControl({ zoom, onChange, defaultZoom = GRID_ZOOM_DEFAULT }: GridZoomControlProps) {
  return (
    <div className="sky-grid-zoom" title="Table zoom — remembered for this table">
      <button
        type="button"
        className="sky-grid-zoom-btn"
        aria-label="Zoom table out"
        disabled={zoom <= GRID_ZOOM_MIN}
        onClick={() => onChange(zoom - GRID_ZOOM_STEP)}
      >
        −
      </button>
      <button
        type="button"
        className="sky-grid-zoom-btn sky-grid-zoom-value"
        title={`Reset to ${Math.round(defaultZoom * 100)}%`}
        onClick={() => onChange(defaultZoom)}
      >
        {Math.round(zoom * 100)}%
      </button>
      <button
        type="button"
        className="sky-grid-zoom-btn"
        aria-label="Zoom table in"
        disabled={zoom >= GRID_ZOOM_MAX}
        onClick={() => onChange(zoom + GRID_ZOOM_STEP)}
      >
        +
      </button>
    </div>
  );
}
